module.exports = __webpack_public_path__ + "img/maestro.fad1d78b.svg";